/**
 * Convert a "YYYY-MM-DD" string to a Date object for v-date-picker binding.
 * Uses T00:00:00 to avoid timezone offset issues.
 *
 * Anything that does not parse (a half-typed date from a text field, an out-of-range
 * date, an ISO datetime) yields `null` rather than an Invalid Date: VDatePicker latches
 * its internal month/year to NaN when an Invalid Date reaches its model, and every later
 * render then throws "Invalid time value" from date-fns.
 */
export function toPickerDate (dateStr: string | Date | null | undefined): Date | null {
  if (!dateStr) {
    return null
  }
  const date = dateStr instanceof Date ? dateStr : new Date(dateStr + 'T00:00:00')
  return Number.isNaN(date.getTime()) ? null : date
}

/**
 * Convert a Date object from v-date-picker to a "YYYY-MM-DD" string.
 */
export function fromPickerDate (date: Date | null | undefined): string | null {
  if (!date || Number.isNaN(date.getTime())) {
    return null
  }
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}
